import {FC} from 'react';

import {ReportUniversal} from '../../components/Reports/report/ReportUniversal';

const ReportUniversalPage: FC = () => {
  return (
    <div>
      <ReportUniversal />
    </div>
  );
};

export default ReportUniversalPage;
